export default __webpack_public_path__ + "static/media/angle.573ed671.svg";